<template>
  <div class="ep-tabs_w-full">
    <div class="ep-tabs__header ep-tabs__row">
      <div :class="classes">
        <slot
          name="tabs"
          :callback="selectTab"
        />
      </div>

      <slot name="extend" />
    </div>

    <slot name="tab" />
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    classes: {
      type: Array,
      default: () => []
    }
  },
  provide() {
    return {
      activeTab: () => this.activeTab
    };
  },
  data() {
    return {
      activeTab: this.$route.meta.id
    };
  },
  methods: {
    selectTab(index) {
      this.activeTab = index;
      this.$emit("update:tab", { index });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/components/_tab.scss";
</style>
